// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"80852729","152":"9acdad6a","181":"cbe42cd9","426":"50cbb264","441":"1851fdd2","466":"a34253b4","507":"7a1546e1","576":"a4b2e67b","602":"56eb6f19","743":"f7c22e42","780":"37266b89","938":"572e400e","968":"5bb6dd22"}[chunkId] + ".chunk.js";
};